export default "__VITE_ASSET__RQcx2PhL__"